<template>
  <div>
    <Input search placeholder="职务名称搜索"></Input>
    <u-tree :data="list" ref="tree" :multiple="multiple" @on-change="onTreeChange"></u-tree>
  </div>
</template>

<script>
import { getPosition } from "../../../api/components";
import mixins from "./mixin"
export default {
  name: "position",
  mixins: [mixins],
  created() {
    this.getAjaxData();
  },
  props: {
    checkedId: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      list: [],
      id: [], //已选职务id
      ajaxData: [], //ajax数据
      checkedList: [] //已选职务列表
    };
  },
  methods: {
    getAjaxData() {
      getPosition()
        .then(res => {
          this.ajaxData = res.data;
        })
        .catch(err => {
          console.log(err);
        });
    },
    formatAjaxData(ajaxData) {
      let checkedId = this.id;
      function jsonTree(data) {
        let result = [];
        data.forEach(item => {
          result.push({
            id: item.id,
            isCheck: item.type === "0",
            title: item.department,
            checked: checkedId.includes(item.id),
            children: jsonTree(item.lists)
          });
        });
        return result;
      }
      let result = jsonTree(ajaxData);
      this.list = result;
    },
    onTreeChange(checkedNodesId, checkNodes) {
      //监听职务tree的变化 nodesId 选中的id, 选中的节点数据
      // this.id = checkedNodesId;
      this.checkedList = checkNodes;
      this.$emit("on-change", this.checkedList);
    },
    delChecked(nodekey) {
      this.$refs.tree.changeNode(nodekey);
    }
  },
  watch: {
    ajaxData: {
      handler() {
        this.formatAjaxData(this.ajaxData);
      },
      deep: true
    },
    checkedId(val) {
      this.id = val;
      this.formatAjaxData(this.ajaxData);
    }
  }
};
</script>

<style scoped>

</style>
